module.exports = __webpack_public_path__ + "static/media/arrow_down_black.bc5fcbcd.svg";